
export function anchors() {
    const $window = this.$window;
    const heightCorrection = $window.innerHeight() / 2;
    const anchorLink = $(".anchor-link a");
    let coords = [];
    let scrolled = $window.scrollTop();
    
    function setCoords() {
        coords = [];
        anchorLink.each(function () {
            const $this = $(this);
            coords.push({elem: $this.attr("href"), position: $($this.attr("href")).offset().top});
        });
    }

    setCoords();

    if($window.innerWidth() >=1200) {
        $(window).on("scroll", function () {
            scrolled = $window.scrollTop();
            coords.forEach(function (item) {
                if(scrolled >= (parseInt(item.position - heightCorrection))) {
                    const elem = $(`[href="${item.elem}"]`);
                    elem.parents("li").addClass("active").siblings("li").removeClass("active");
                }
            });
        }) ;
    };

    anchorLink.on("click", function (event) {
        event.preventDefault();
        const menuItem = $(event.target);
        const sectionID = menuItem.attr("href");
        $("html, body").animate({
            scrollTop: $(sectionID).offset().top
        }, 700);
    });

    $window.on("resize", function () {
        setCoords();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchors.js